import React, { HTMLProps, forwardRef } from 'react';

const JDAInlineVideo = forwardRef<HTMLVideoElement, HTMLProps<HTMLVideoElement>>((props, ref) => (
  <video ref={ref} muted loop playsInline autoPlay {...props} />
));

export default JDAInlineVideo;
